import { createSelector } from 'reselect';

import type { AppState } from '../../store/types';

export const getStorages = (state: AppState) => state.entities.storages;

export const getStorageNameById = (state: AppState, id: string) => {
  return getStorages(state)[id]?.name;
};

export const selectArchiveStorages = createSelector(getStorages, (storages) =>
  Object.values(storages).filter((storage) => storage.purpose === 'ARCHIVE'),
);

export const selectDefaultFaceRecognitionStorages = createSelector(
  getStorages,
  (storages) =>
    Object.values(storages).filter(
      (storage) => storage.purpose === 'FACES' && storage.default === true,
    ),
);
